import { useFeatures } from "@portal/hooks/use-features";
import { invoiceStatusesConfig } from "./predicate";
import { forEach, isArray, union, update } from "lodash";
import {
  InvoiceDerivedStatus,
  InvoiceStatus,
} from "@portal/types/entities/invoice";

interface updateConfigProps {
  condition: boolean;
  statusKeys: InvoiceDerivedStatus[];
  statusToAdd: InvoiceStatus;
}

export function useGetInvoiceStatusesConfig() {
  const { getDraftFeatures, getWriteOffFeatures } = useFeatures();
  const draftMetricFlag = getDraftFeatures("DRAFT_METRICS");
  const draftInvoiceFlag = getDraftFeatures("DRAFT_INVOICE");
  const isWriteOffInvoiceFlag = getWriteOffFeatures("WRITE_OFF");
  const isDraftEnabled=draftInvoiceFlag || draftMetricFlag
  const updateConfig: updateConfigProps[] = [
    {
      condition: isDraftEnabled,
      statusKeys: ["ALL", "OPEN"],
      statusToAdd: "DRAFT",
    },
    {
      condition: isWriteOffInvoiceFlag,
      statusKeys: ["ALL", "CLOSED"],
      statusToAdd: "WRITE_OFF",
    },
  ];

  function getModifiedInvoiceStatuses() {
    const modifiedStatuses = { ...invoiceStatusesConfig };
    forEach(updateConfig, ({ condition, statusKeys, statusToAdd }) => {
      if (condition) {
        forEach(statusKeys, (key) => {
          update(modifiedStatuses, key, (currentStatuses) =>
            union(
              currentStatuses || [],
              isArray(statusToAdd) ? statusToAdd : [statusToAdd]
            )
          );
        });
      }
    });

    return modifiedStatuses;
  }
  const statuses = getModifiedInvoiceStatuses();
  return statuses;
}
